import React, {Component} from 'react';
import {Form, Field} from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import {FieldArray} from 'react-final-form-arrays'
import PropTypes from 'prop-types';

function formatMoney(money) {
  // TODO: Implement me
  return money;
}

export default class ScheduleEFView extends Component {
  static propTypes = {
    schedule_ef: PropTypes.object,
  };

  priority_creditor_item = (creditor) => (
    <tr>
      <td>
        <table>
          <thead>
          <tr>
            <td colspan="2"></td>
            <td class="total-claim">
              <label for="">
                <span class="label">Total claim</span>
              </label>
            </td>
            <td class="priority-amount">
              <label for="">
                <span class="label">Priority amount</span>
              </label>
            </td>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <label for="">
                <span class="label">Priority creditor's name and mailing address</span>
              </label>
              <span id="address">{creditor.creditor}</span>
            </td>
            <td>
              <label for="">
                <span class="label">As of petition filing date, the claim is:</span>
              </label>
              <input type="checkbox" name="claim_type" disabled={true}
                     checked={creditor.is_contingent}/> Contingent<br/>
              <input type="checkbox" name="claim_type" disabled={true} checked={creditor.is_unliquidated}/> Unliquidated<br/>
              <input type="checkbox" name="claim_type" disabled={true} checked={creditor.is_disputed}/> Disputed
            </td>
            <td class="money">
              <span id="total-claim">$ {formatMoney(creditor.total_claim)}</span>
            </td>
            <td class="money">
              <span id="priority-amount">$ {formatMoney(creditor.priority_amount)}</span>
            </td>
          </tr>
          <tr>
            <td>
              <label for="">
                <span class="label">Date or dates debt was incurred</span>
              </label>
              {creditor.debt_date}
            </td>
            <td>
              <label for="">
                <span class="label">Basis for the claim</span>
              </label>
              {creditor.claim_basis}
            </td>
          </tr>
          <tr>
            <td>
              <label for="">
                <span class="label">Last 4 digits of account number</span>
              </label>
              {creditor.account_number_last_4_digits}
            </td>
            <td rowspan="2">
              <label for="">
                <span class="label">Is the claim subject to offset?</span>
              </label>
              <input type="radio" name="is_offset_claim" value="No" disabled={true}
                     checked={creditor.is_subject_to_offset}/> No<br/>
              <input type="radio" name="is_offset_claim" value="Yes" disabled={true}
                     checked={creditor.is_subject_to_offset}/> Yes
            </td>
          </tr>
          <tr>
            <td>
              <label for="">
                <span class="label">Specify Code subsection of PRIORITY unsecured claim:</span>
              </label>
              11 U.S.C. § 507(a) ({creditor.usc_subsection})
            </td>
          </tr>
          </tbody>
        </table>
      </td>
    </tr>
  );

  nonpriority_creditor_item = creditor => (
    <tr>
      <td>
        <table>
          <thead>
          <tr>
            <td colspan="2"></td>
            <td class="total-claim">
              <label for="">
                <span class="label">Amount of claim</span>
              </label>
            </td>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td rowspan="2">
              <label for="">
                <span class="label">Nonpriority creditor's name and mailing address</span>
              </label>
              <span id="address">{creditor.creditor}</span>
            </td>
            <td>
              <label for="">
                <span class="label">As of petition filing date, the claim is:</span>
              </label>
              <input type="checkbox" name="claim_type" disabled checked={creditor.is_contingent}/> Contingent<br/>
              <input type="checkbox" name="claim_type" disabled checked={creditor.is_unliquidated}/> Unliquidated<br/>
              <input type="checkbox" name="claim_type" disabled checked={creditor.is_disputed}/> Disputed
            </td>
            <td class="money">
              <span id="total-claim">$ {formatMoney(creditor.total_claim)}</span>
            </td>
          </tr>
          <tr>
            <td>
              <label for="">
                <span class="label">Basis for the claim</span>
              </label>
              {creditor.claim_basis}
            </td>
          </tr>
          <tr>
            <td>
              <label for="">i
                <span class="label">Date or dates debt was incurred</span>
              </label>
              {creditor.date}
            </td>
            <td rowspan="2">
              <label for="">
                <span class="label">Is the claim subject to offset?</span>
              </label>
              <input type="radio" name="is_offset_claim" value="No" disabled
                     checked={creditor.is_claim_subject_to_offset}/> No<br/>
              <input type="radio" name="is_offset_claim" value="Yes" disabled
                     checked={creditor.is_claim_subject_to_offset}/> Yes
            </td>
          </tr>
          <tr>
            <td>
              <label for="">
                <span class="label">Last 4 digits of account number</span>
              </label>
              {creditor.account_number_last_4_digits}
            </td>
          </tr>
          </tbody>
        </table>
      </td>
    </tr>
  );

  render() {
    if (this.props.schedule_ef.empty)
      return <div>{this.props.schedule_ef.empty}</div>


    const { priority_creditors, non_priority_creditors } = this.props.schedule_ef.data;


    return (
      <div id="schedule-ef">
        <div id="schedule-ef-filters">
          <form id="parser-schedule-ef-form">
            <input
              type="text" name="keyword" id="alfresco-keyword"
              class="form-text"
              size="30"
              placeholder="Enter Keywords"
            />

            $<input
            type="text" name="value_from" id="value-from" placeholder="value"
            class="form-text"
          /> to
            $<input
            type="text" name="value_to" id="value-to" placeholder="value"
            class="form-text"
          />

            <button type="submit" class="form-submit">
              <span class="magnifier icon"></span>
            </button>
            <a href="#" id="alfresco-clear">clear</a>
          </form>
        </div>

        <div id="ir-search-schedule-ef-results">
          <table id="priority-creditors">
            <thead>
            <tr>
              <th>Priority creditors</th>
            </tr>
            </thead>
            <tbody>
            {priority_creditors && priority_creditors.map(this.priority_creditor_item)}
            </tbody>
          </table>

          <table id="nonpriority-creditors">
            <thead>
            <tr>
              <th>Nonpriority creditors</th>
            </tr>
            </thead>
            <tbody>
            {non_priority_creditors && non_priority_creditors.map(this.nonpriority_creditor_item)}

            </tbody>
          </table>
        </div>
      </div>
    )
  }

}


/** WEBPACK FOOTER **
 ** ./src/scheduleform/ScheduleEFView.jsx
 **/